/**
 * **Ein Fenster, das vor dem `await` aufgeht.** `window.open` nach einem
 * `await` blockiert der Browser als Popup. Deshalb öffnet der Klick das
 * Fenster sofort leer (synchron im Klick-Handler), und die Adresse kommt nach,
 * sobald der Server sie signiert hat.
 */
export interface PendingWindow {
  go(url: string): void;
  close(): void;
}

export function openPending(): PendingWindow {
  const w = window.open("about:blank", "_blank");
  return {
    go(url) {
      if (!w) { window.location.href = url; return; }
      // Die Instanz ist dieselbe Site: ohne das könnte sie über `opener` diese
      // Seite woandershin schicken.
      w.opener = null;
      w.location.href = url;
    },
    close() { w?.close(); },
  };
}
